import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledUsernameRegexConditionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

export const StyledUsernameRegexCondition = styled.div`
  display: flex;
  gap: 0.9rem;

  color: ${({ theme }) => theme.colors.text.lighter};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
`;

export const StyledRegexInvalidDot = styled.div`
  margin-left: 0.8rem;
`;

export const StyledFontAwesomeCheckIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledFontAwesomeCheckIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.success.main};
`;
